var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { "margin-top": "20px" },
          attrs: {
            data: _vm.list.value,
            border: "",
            height: "650",
            "row-key": "id",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "id",
              label: "ID",
              width: "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: "策略名称",
              "min-width": "150",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "popupTypeName",
              label: "弹窗类型",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "channelInfo",
              label: "渠道配置",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "versionRangeInfo",
              label: "版本配置",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "uidFilterInfo",
              label: "UID",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "showJumpButtonName",
              label: "展示跳转",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.showJumpButton === 1
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("展示"),
                        ])
                      : row.showJumpButton === 0
                      ? _c("el-tag", { attrs: { type: "info" } }, [
                          _vm._v("不展示"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "showJumpName",
              label: "关联跳转",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "showReservedButtonName",
              label: "展示预留",
              width: "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.showReservedButton === 1
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("展示"),
                        ])
                      : row.showReservedButton === 0
                      ? _c("el-tag", { attrs: { type: "info" } }, [
                          _vm._v("不展示"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "title",
              label: "按钮标题",
              "min-width": "120",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "statusName", label: "状态", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.status === 1
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("生效"),
                        ])
                      : row.status === 0
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("失效"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "remark",
              label: "备注",
              "min-width": "150",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "updateTime", label: "更新时间", width: "160" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "150", fixed: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "UPGRADE_POPUP_LOG",
                            expression: "'UPGRADE_POPUP_LOG'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.viewLog(row)
                          },
                        },
                      },
                      [_vm._v("日志")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "UPGRADE_POPUP_EDIT",
                            expression: "'UPGRADE_POPUP_EDIT'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.edit(row.id)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "UPGRADE_POPUP_DEL",
                            expression: "'UPGRADE_POPUP_DEL'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.del(row.id)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("ElementPagination", {
        staticStyle: { "margin-bottom": "20px" },
        attrs: {
          "current-page": _vm.searchParams.current,
          "page-size": _vm.searchParams.size,
          total: _vm.searchParams.total,
          "page-sizes": [10, 20, 30, 40, 50],
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c("OptionLog", {
        ref: "optionLog",
        attrs: { columnConfig: _vm.optionLogColumn, closeBtn: false },
        on: { reload: _vm.reloadOpt },
      }),
      _c("EditDialog", { ref: "editDialog", on: { reload: _vm.getList } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }